export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    const element = this.$el;

    document.addEventListener("DOMContentLoaded", function () {
      element.style.opacity = "0";
      element.style.transform = "translateY(80px)";
      let windowHeight = window.innerHeight;

      function isInViewport(image) {
        let rect = image.getBoundingClientRect();

        return rect.top >= 0 && rect.top <= windowHeight;
      }

      function showElement() {
        if (isInViewport(element)) {
          element.style.opacity = "1";
          element.style.transform = "translateY(0)";
        }
      }

      showElement();

      window.addEventListener("scroll", showElement);
    });
  },
  methods: {},
};
